import type { Currency } from 'utils/Currency';
import type { InstallmentConfig } from 'utils/installmentConfig';
import { CurrencySymbol, formatPriceWithComma } from 'hooks/pricing/useFormattedPrice';
import styles from './PriceDisplay.module.css';

export type PriceDisplayProps = {
  price: number;
  strikedPrice?: number;
  currency: Currency;
  installmentConfig?: InstallmentConfig | null;
};

export const PriceDisplay = ({
  price,
  strikedPrice,
  currency,
  installmentConfig,
}: PriceDisplayProps) => {
  const currencyEnum = currency.toLowerCase() as Currency;
  const symbol = CurrencySymbol[currencyEnum];
  const showStrike = typeof strikedPrice === 'number' && strikedPrice > price;
  const installmentPrice = installmentConfig
    ? Math.ceil(price / installmentConfig.months)
    : null;

  return (
    <p className={styles.container}>
      {showStrike ? (
        <span className={styles['strike-through']}>
          {symbol}
          {formatPriceWithComma(strikedPrice as number, currencyEnum)}
        </span>
      ) : null}
      <span className={styles['current-price']}>
        {symbol}
        {formatPriceWithComma(price, currencyEnum)}
      </span>
      {installmentPrice && installmentConfig ? (
        <span className={styles.installment}>
          or&nbsp;{symbol}
          {formatPriceWithComma(installmentPrice, currencyEnum)}/{installmentConfig.label}&nbsp;
          <span className={styles['installment-symbol']}>&plusmn;</span>
        </span>
      ) : null}
    </p>
  );
};
